import { render, staticRenderFns } from "./CreateStagePrompt.vue?vue&type=template&id=b7519236&lang=pug&"
import script from "./CreateStagePrompt.vue?vue&type=script&lang=js&"
export * from "./CreateStagePrompt.vue?vue&type=script&lang=js&"
import style0 from "./CreateStagePrompt.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports